<template>
	<div class="clns">
        <main>
            <div class="list">
                <h2 style="text-align:center">车辆尿素</h2>

                <van-field
                    v-model="chepai"
                    center
                    label="车牌"
                    placeholder="请输入车牌"
                >
                    <template #button>
                        <van-button size="mini" type="danger" @click="searchCar()">搜索</van-button>
                    </template>
                </van-field>

                <van-field label="部门" v-model="bumen" readonly />
                <van-field label="车辆类型" v-model="chepai_1" readonly />
                <van-field label="车辆状态" v-model="xz_status" readonly />
                
                <van-field label="所属公司" v-model="chepai_2" readonly />
                <van-field label="使用公司" v-model="chepai_3" type="textarea" readonly autosize/>

                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="time"
                    label="操作时间"
                    placeholder="点击选择操作时间"
                    @click="showPicker3 = true"
                />

                <van-popup v-model:show="showPicker2" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="columns2"
                        @confirm="onConfirm2"
                        @cancel="showPicker2 = false"
                    />
                </van-popup>

                <van-popup v-model:show="showPicker3" position="bottom">
                    <van-datetime-picker
                        :max-date="maxDate"
                        v-model="currentDate"
                        type="datetime"
                        @confirm="onConfirm3"
                        @cancel="showPicker3 = false"
                    />
                </van-popup>

                <van-popup v-model:show="showPicker4" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="columns4"
                        @confirm="onConfirm4"
                        @cancel="showPicker4 = false"
                    />
                </van-popup>

                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="fangshi"
                    label="操作方式"
                    placeholder="点击选择操作方式"
                    @click="showPicker4 = true"
                />

                <van-field label="金额" v-model="money" />
                <van-field label="卡号" v-model="yk_num" readonly/>
                <van-field label="余额" v-model="yk_yue" readonly/>

                <van-field label="驾驶员" v-model="name" />
                <van-field label="升数" v-model="shengshu" type="number" />
               
                <van-field label="备注" v-model="mess" />

                <div style="margin-left:16px">
                    <h4>照片</h4>
                    <van-uploader  v-model="fileList" multiple :max-count="3"  :before-read="beforeRead"/>
                </div>

                <van-button type="danger" style="width:100%;margin-top:40px" :disabled="disabled" @click="sub()">提交</van-button>

            </div>
        </main>
    </div>
</template>

<script>
    import { url2,carList,ykList } from '../router/api';
	export default{
		data(){
			return{
                showPicker2:false,
                showPicker3:false,
                showPicker4:false,
                disabled:false,
                columns2:[],
                columns4: ['油卡','现金'],
                currentDate: new Date(),
                
                chepai:'',
                chepai_1:'',
                chepai_2:'',
                chepai_3:'',
                bumen:'',
                xz_status:'',

                time:'',
                name:'',
                shengshu:'',
                fangshi:'',
                money:'',
                yk_num:'',
                yk_yue:'',
                mess:'',
                fileList:[],

                readonly:false,
                maxDate: new Date(),
            }
        },


		methods: {
            sub() {
                if(this.chepai==''||this.chepai_1=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请填写正确车牌',
                    }).then(() => {
                        return;
                    });
                } else if(this.time=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请选择操作时间',
                    }).then(() => {
                        return;
                    });
                } else if(this.fangshi=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请选择操作方式',
                    }).then(() => {
                        return;
                    });
                }  else if(this.money=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请填写金额',
                    }).then(() => {
                        return;
                    });
                } else if(this.name=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请填写驾驶员',
                    }).then(() => {
                        return;
                    });
                }  else if(this.shengshu=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请填写升数',
                    }).then(() => {
                        return;
                    });
                } else if(this.fileList=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请上传照片',
                    }).then(() => {
                        return;
                    });
                } else {
                    this.loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: '加载中',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var formData =new FormData();
                    this.fileList.map(item=>{
                        formData.append('file[]',item.file);
                    })
                    this.axios.post(url2+'upload5',(formData),{
                        headers: {  'Content-Type': 'multipart/form-data;' }
                    }).then(res=> {
                        if(res.data.code==1) {
                            this.sure2(res.data.data)
                        }  else {
                            this.loading.close();
                        }
                    }).catch(err=> {
                        this.loading.close();
                        console.log(err);
                    });
                }
            },

            sure2(photo) {
                this.axios.get(url2+'niaosu', {
                    params:{
                        chepai:this.chepai,
                        chepai_1:this.chepai_1,
                        chepai_2:this.chepai_2,
                        chepai_3:this.chepai_3,
                        bumen:this.bumen,
                        xz_status:this.xz_status,
                        time:this.time,
                        name:this.name,
                        shengshu:this.shengshu,
                        fangshi:this.fangshi,
                        money:this.money,
                        num:this.yk_num,
                        yue:this.yk_yue,
                        mess:this.mess,
                        url:photo.toString(),
                    }
                }).then(res=> {
                    if(res.data.code==1) {
                        this.loading.close();
                        this.$dialog.alert({
                            title: '提示',
                            message: '提交成功',
                        }).then(() => {
                            this.disabled = true
                        });
                    } else {
                        this.$dialog.alert({
                            title: '提示',
                            message: '失败',
                        }).then(() => {
                            this.loading.close();
                            this.disabled = false
                        });
                    }
                }).catch(err=> {
                    this.loading.close();
                    console.log(err);
                });
            },

            searchCar() {
                carList({
                    id:'',
                    chepai:this.chepai ? this.chepai: '',
                    xz_status:'',
                    gongsi: '' ,
                }).then(res=> {
                    if(res.code==1) {
                        res.data.map(item=>{
                            item.text = item.chepai
                            delete (item.chepai)
                        })
                        this.columns2 = res.data
                    }
                }).catch(err=> {
                    console.log(err);
                });
                this.showPicker2 = true
            },

            async onConfirm2(value) {
                this.chepai = value.text
                this.chepai_1 = value.type
                this.chepai_2 = value.shu_org
                this.chepai_3 = value.yong_org
                this.youhao = value.youhao
                this.bumen = value.bumen
                this.xz_status = value.xz_status
                this.showPicker2 = false;
                this.yk_num = '';
                this.yk_yue = '',
                ykList({
                    id:'',
                    org:value.yong_org,
                    chepai:value.text,
                    zfk:'',
                }).then(res=> {
                    if(res.code==1) {
                        if(res.data.length>0) {
                            this.yk_num = res.data[0].num
                            this.yk_yue = res.data[0].money
                        }
                    }
                }).catch(err=> {
                    console.log(err);
                });
            },
            onConfirm3(value) {
                this.time = this.formatDate(value)
                this.showPicker3 = false;
            },
            onConfirm4(value) {
                this.fangshi = value
                this.showPicker4 = false;
            },

             formatDate(date) {
                let y = date.getFullYear()
                let m = date.getMonth() + 1
                let d = date.getDate()
                let hh = date.getHours()
                let mm = date.getMinutes()
                m = m < 10 ? '0' + m : m
                d = d < 10 ? '0' + d : d
                hh = hh < 10 ? '0' + hh : hh
                mm = mm < 10 ? '0' + mm : mm
                return `${y}-${m}-${d} ${hh}:${mm}`;
            },
            beforeRead(file){
                return this.$compress(file)
            },
        }
    }
</script>

<style scoped="scoped" lang='less'>
    .clns main {
        font-size: 14px;
        padding: 40px 16px;
        background-color: #FFDCA3;
    }
    .clns .list {
        background-color: #fff;
        padding: 20px 20px 80px 20px;
    }
</style>